export const FETCH_FAQ_POST_START = 'FETCH_FAQ_POST_START';
export const FETCH_FAQ_POST_SUCCESS = 'FETCH_FAQ_POST_SUCCESS';
export const FETCH_FAQ_POST_FAILED = 'FETCH_FAQ_POST_FAILED';

export const CLEAER_POST_INFO = 'CLEAER_POST_INFO';

export const SET_ACTIVE_POST = 'SET_ACTIVE_POST';
export const SET_ACTIVE_CATEGORY = 'SET_ACTIVE_CATEGORY';
